/**
 * AI CONTEXT
 * Purpose: teacher workspace with schedule, attendance, and class detail panels.
 * Key deps: TeacherViewContextProvider, TeacherSchedule, TeacherAttendance, TeacherClassInfo.
 * Referenced by: App route ROUTES.TEACHER_VIEW.
 * Importance: primary in-class operational UI for teachers.
 * Refactor: persist panel widths + improve no-selection empty states.
 */
import { Splitter } from "antd"

import EmptyPage from "#blocks/EmptyPage"
import Page from "#blocks/Page"
import { HEADER_HEIGHT } from "#components/Header"
import { useThemeContext } from "#contexts/ThemeContextProvider"
import { RESOURCES } from "#customTypes/composedTypes/authTypes"
import { useResourcePermissions } from "#hooks/newHooks/useHasPermission"

import TeacherAttendance from "./TeacherAttendance"
import TeacherClassInfo from "./TeacherClassInfo"
import TeacherSchedule from "./TeacherSchedule"
import TeacherViewContextProvider from "./TeacherViewContextProvider"

const TeacherView = () => {
  const { body1, body2 } = useThemeContext()

  const { canRead } = useResourcePermissions(RESOURCES.TEACHER_VIEW)

  if (!canRead) {
    return (
      <Page>
        <EmptyPage />
      </Page>
    )
  }

  return (
    <TeacherViewContextProvider>
      <Page>
        <Splitter
          style={{
            height: `calc(100vh - ${HEADER_HEIGHT}px)`,
            background: `linear-gradient(to right, ${body1}, ${body2})`,
          }}
        >
          <Splitter.Panel defaultSize={430} min={300} max={600}>
            <TeacherSchedule />
          </Splitter.Panel>
          <Splitter.Panel min={400}>
            <TeacherAttendance />
          </Splitter.Panel>
          <Splitter.Panel defaultSize={470} min={280} max={600}>
            <TeacherClassInfo />
          </Splitter.Panel>
        </Splitter>
      </Page>
    </TeacherViewContextProvider>
  )
}

export default TeacherView
